import React from 'react';
import { useSelector } from '@ecommerce/nest-ssr/common';
import { isFrontPage } from 'helpers/url-manager';
import { PageProps } from 'interfaces/page-props';

const StructuredData: React.FC = () => {
    const pageUrl = useSelector((state: PageProps) => state.pageUrl);

    const organizationStructuredData = {
        '@context': 'http://schema.org/',
        '@type': 'Organization',
        'url': 'https://www.skapiec.pl/',
        'logo': 'https://ocdn.eu/skapiec/logo-blue-background.svg',
        'sameAs': [
            'https://www.instagram.com/skapiec_pl/',
            'https://www.facebook.com/Skapiec'
        ],
        'contactPoint': {
            '@context': 'http://schema.org/',
            '@type': 'ContactPoint',
            'telephone': '12-26-00-200',
            'contactType': 'customer service',
            'areaServed': 'PL',
            'availableLanguage': 'Polish'
        }
    };

    const webSiteStructuredData = {
        '@context': 'http://schema.org/',
        '@type': 'WebSite',
        'name': 'Skąpiec.pl',
        'url': 'https://www.skapiec.pl/',
        'potentialAction': {
            '@type': 'SearchAction',
            'target': {
                '@type': 'EntryPoint',
                'urlTemplate': 'https://www.skapiec.pl/szukaj?query={search_term_string}'
            },
            'query-input': 'required name=search_term_string'
        }
    };

    return (
        <>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationStructuredData) }}
            />
            {isFrontPage(pageUrl) && (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteStructuredData) }}
                />
            )}
        </>
    );
};

export default StructuredData;
